import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SeatBookingModal from '../components/SeatBookingModal';
import OpeningHoursDisplay from '../components/OpeningHoursDisplay'; // Correctly import the component
import api from '../utils/api'; 
import './HomePage.css'; 

import heroImage from '../assets/library-hero.jpg';

const SeatGrid = ({ seats, handleBookNow }) => {
    return (
        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
            {seats.map(seat => (
                <Col key={seat._id}>
                    <Card 
                        className={`text-center h-100 shadow-sm seat-card ${seat.isOccupied ? 'occupied' : 'available'}`}
                    >
                        <Card.Body>
                            <h5 className="seat-number">Seat {seat.seatNumber}: {seat.title}</h5>
                            <p className="seat-status">{seat.isOccupied ? 'Occupied' : 'Available'}</p>
                            {!seat.isOccupied && (
                                <Button 
                                    className="btn-luxury mt-2" 
                                    onClick={() => handleBookNow(seat)}
                                >
                                    Book Now
                                </Button>
                            )}
                        </Card.Body>
                    </Card>
                </Col>
            ))}
        </Row>
    );
};

const HomePage = () => {
    const [seats, setSeats] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedSeat, setSelectedSeat] = useState(null);
    const navigate = useNavigate();

    const seatSectionRef = useRef(null);
    const isAuthenticated = localStorage.getItem('userId');

    // The hardcoded libraryHours object is no longer needed here
    // const libraryHours = { ... };

    const contactData = {
        name: 'Prince Kumar',
        mobile: '8298396568',
        address: 'Begusarai'
    };

    const fetchSeats = async () => {
        try {
            const response = await api.get('/seats'); 
            const now = new Date();
            const seatsWithStatus = response.data.seats.map(seat => {
                const isOccupied = seat.bookings.some(booking => 
                    booking.status === 'Active' && now >= new Date(booking.startTime) && now <= new Date(booking.endTime)
                );
                return { ...seat, isOccupied };
            });
            setSeats(seatsWithStatus);
            setLoading(false);
        } catch (err) {
            setError('Failed to fetch seat data.');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSeats();
    }, []);

    const handleBookNow = (seat) => {
        if (!isAuthenticated) {
            navigate('/login');
        } else {
            setSelectedSeat(seat);
            setShowModal(true);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedSeat(null);
    };
    
    const handleBookingSuccess = (updatedSeat) => {
        fetchSeats();
        handleCloseModal();
    };

    const handleExploreClick = () => {
        seatSectionRef.current.scrollIntoView({ behavior: 'smooth' });
    };

    const totalSeats = seats.length;
    const availableSeats = seats.filter(seat => !seat.isOccupied).length;

    return (
        <main>
            <div className="modern-hero-section" style={{ backgroundImage: `url(${heroImage})` }}>
                <div className="hero-content">
                    <h1 className="display-4 fw-bold animate-text" style={{ color: 'white' }}>Welcome to Aaradhya Library</h1>
                    <p className="lead animate-text">Your perfect space for focus and learning.</p>
                    <Button 
                        className="btn btn-luxury-alt btn-lg animate-text" 
                        onClick={handleExploreClick}
                    >
                        Explore Seats
                    </Button>
                </div>
            </div>

            <Container className="my-5">
                <Row className="g-4">
                    <Col md={8}>
                        <Card className="p-4 shadow-sm h-100">
                            <h2 className="mb-4">About Aaradhya Library</h2>
                            <p>Welcome to Aaradhya Library, your premier destination for a peaceful and productive study environment in Begusarai.</p>
                            <hr />
                            <h5>Owner: {contactData.name}</h5>
                            <h5>Contact: {contactData.mobile}</h5>
                            <h5>Location: {contactData.address}</h5>
                        </Card>
                    </Col>
                    <Col md={4}>
                        {/* The OpeningHoursDisplay component is now correctly used here */}
                        <OpeningHoursDisplay />
                    </Col>
                </Row>

                <div className="mt-5 text-center" ref={seatSectionRef}>
                    <h2>Current Seat Availability</h2>
                    <p className="lead text-muted">{availableSeats} of {totalSeats} seats available</p>
                    <div className="mt-4">
                        {loading ? (
                            <p>Loading seat data...</p>
                        ) : error ? (
                            <p className="text-danger">{error}</p>
                        ) : (
                            <SeatGrid seats={seats} handleBookNow={handleBookNow} />
                        )}
                    </div>
                </div>
            </Container>
            
            {selectedSeat && (
                <SeatBookingModal 
                    show={showModal} 
                    handleClose={handleCloseModal} 
                    seat={selectedSeat} 
                    onBookingSuccess={handleBookingSuccess}
                />
            )}
        </main>
    );
};

export default HomePage;